export default "/build/images/leaf_mask.f4f98725.png";